import doRequest from '@/api/dssRequest';
import store from "../store.js"; // Uses the library to store or retrieve generic data

export class QuestionData {

  constructor() {
    this.questionId = ""
    this.ranking = 0
    this.name = ""
    this.description = ""
    this.pictureUrl = ""
    this.videoUrl = ""
    this.answerType = ""  // "Text", "Number", "Picture", "Video", "MultiChoice"
    this.correctAnswer = ""
    this.answers = []

    this.givenAnswer = ""
    this.base64image = ""
    this.videoId = ""
  }

  // Parse the Question data in the EventDetails response.
  parseData(data) {
    this.questionId = data.QuestionItemId
    this.ranking = data.Ranking
    this.name = data.Name
    this.description = data.Description
    this.pictureUrl = data.PictureUrl
    this.videoUrl = data.VideoUrl ? data.VideoUrl : ""
    this.answerType = data.AnswerType
    this.correctAnswer = data.correctAnswer
    this.answers = data.Answers
  }  
}

export default class QuizQuestionDataModel {

  constructor() {
    // Array of question data from EventDetails.
    this.questions = []
  }

  // Parse the array of Question data in the EventDetails response.
  parseData(data) {
    this.questions = []
    if (data.QuestionItems != null) {
      if (Array.isArray(data.QuestionItems)) {
        console.log(`QuizQuestionDataModel::parseData - Found QuestionItems in EventDetails.`)
        console.log(data.QuestionItems)
        data.QuestionItems.forEach(element => {
          let question = new QuestionData()
          question.parseData(element)
          this.questions.push(question)
        });
        console.log(`QuizQuestionDataModel::parseData - Parsed: ${this.questions.length} questions successfull.`)
      } else {
        console.log(`QuizQuestionDataModel::parseData - ERROR! QuestionItems in EventDetails is not an array.`)
      }
    } else {
      console.log(`QuizQuestionDataModel::parseData - ERROR! Failed to read QuestionItems from EventDetails.`)
    }
  }

  setupTestData() {
    this.questions = []

    let question1 = new QuestionData()
    question1.name = "Name of Question 1"
    question1.description = "Description of Question 1"
    question1.answerType = "MultiChoice"
    question1.answers.push("Answer 1")
    question1.answers.push("Answer 2")
    question1.answers.push("Answer 3")
    question1.answers.push("Answer 4")
    this.questions.push(question1)

    let question2 = new QuestionData()
    question2.name = "Name of Question 2"
    question2.description = "Description of Question 2"
    question2.pictureUrl = "https://test05.superlinda.nl/images/lrs3dq8i9l6wrwmh.png"
    question2.answerType = "Text"
    this.questions.push(question2)

    let question3 = new QuestionData()
    question3.name = "Name of Question 3"
    question3.description = "Description of Question 3"
    question3.videoUrl = "https://test05.superlinda.nl/images/1628004700.mp4"
    question3.answerType = "Number"
    this.questions.push(question3)

    let question4 = new QuestionData()
    question4.name = "Name of Question 4"
    question4.description = "Description of Question 4"
    question4.answerType = "Picture"
    this.questions.push(question4)

    let question5 = new QuestionData()
    question5.name = "Name of Question 5"
    question5.description = "Description of Question 5"
    question5.answerType = "Video"
    this.questions.push(question5)
  }

  sendData(eventId, email, firstName, successCallback, errorCallback) {
    const payload = {
      EventId: eventId,
      Email: email,
      FirstName: firstName,
      Answers: [],
    };

    this.questions.forEach(element => {
      const answer = new Object()
      answer.QuestionItemId = element.questionId
      if (element.answerType === 'MultiChoice' || element.answerType === 'Text' || element.answerType === 'Number') {
        answer.Answer = element.givenAnswer
      } else if (element.answerType === 'Picture') {
        answer.Answer = element.base64image
      } else if (element.answerType === 'Video') {
        answer.Answer = element.videoId
      }
      payload.Answers.push(answer)
    });

    doRequest(
      (response) => {
        console.log("Received a valid response:")
        console.log(response)
        successCallback()
      },
      (error) => {
        console.error("Received an error on answerQuiz request.")
        errorCallback()
      },
      'answerQuiz',
      `${store.getters['Account/partnerGroupDetails'].AccountId}_UM`,
      payload
    );
  }

  checkAnswers() {
    for (let i=0; i < this.questions.length; i++) {
      let element = this.questions[i]
      if (element.answerType === 'MultiChoice' || element.answerType === 'Text' || element.answerType === 'Number') {
        if (element.givenAnswer == null || element.givenAnswer === '') {
          return `answer_${i}`
        }
      } else if (element.answerType === 'Picture') {
        if (element.base64image === '') {
          return `answer_${i}`
        }
      } else if (element.answerType === 'Video') {
        if (element.videoId === '') {
          // return `answer_${i}`
        }
      }
    }
    return ''
  }
}